import { render, staticRenderFns } from "./EditRolePrivilege.vue?vue&type=template&id=7120a40d&scoped=true&"
import script from "./EditRolePrivilege.vue?vue&type=script&lang=js&"
export * from "./EditRolePrivilege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7120a40d",
  null
  
)

export default component.exports